export class TrackBy {
    trackByItem = (index: number, item: any) => item;
}